export default "__VITE_ASSET__DLdgA_O8__"